import {
  ApplicationConfig,
  isDevMode,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideEffects } from "@ngrx/effects";
import { provideState, provideStore } from "@ngrx/store";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { routes } from "./app.routes";
import { authInterceptor } from "./interceptors/auth/auth.interceptor";
import { errorInterceptor } from "./interceptors/error/error.interceptor";
import { provideServiceWorker } from "@angular/service-worker";
import { appAppearanceReducer } from "./common/stores/app-appearance/app-appearance.reducers";
import * as loadAppAppearanceEffect from "./common/stores/app-appearance/app-appearance.effect";
import { DatePipe } from "@angular/common";
import { extensionAgentListReducer } from "./common/stores/extensions-agentlist/extension-agentlist.reducer";
import { ExtensionAgentListEffects } from "./common/stores/extensions-agentlist/extension-agentlist.effects";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideStore(),
    provideEffects(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    provideServiceWorker("ngsw-worker.js", {
      enabled: !isDevMode(),
      registrationStrategy: "registerWhenStable:30000",
    }),
    provideState("appAppearance", appAppearanceReducer),
    provideEffects(loadAppAppearanceEffect),
    provideState({ name: "extension", reducer: extensionAgentListReducer }),
    provideEffects(ExtensionAgentListEffects),
    DatePipe,
  ],
};
